import { apiClient } from "./client";
import { API_ENDPOINTS } from "./endpoints";

export const notificationsApi = {
  /**
   * Send welcome notification when user adds the miniapp
   * Fire-and-forget - errors are silently ignored
   */
  sendWelcome: async (fid: number): Promise<void> => {
    try {
      await apiClient.post(API_ENDPOINTS.NOTIFICATIONS.WELCOME, { fid });
    } catch {
      // Silent fail - welcome notification is non-critical
    }
  },
};
